// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0e0b2ce1","239":"e527af9e","453":"9537af23","667":"b19a3f7e"}[chunkId] + ".chunk.js";
};